import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { ProviderValue, useAxios } from '../../config/axios-config';
import { Customer } from '../../model/Customer'
import { CustomerMeal } from '../../model/CustomerMeal'
import { Meal } from '../../model/Meal'
import { Col, Divider, List, Popconfirm } from 'antd'
import { IconButton, Tooltip, Zoom } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Button, Modal } from 'react-bootstrap'
import { LocalDate } from 'local-date'
import dayjs from 'dayjs';
import 'dayjs/locale/pl'
import { CustomerMealRequestDTO } from '../../model/CustomerMealRequestDTO';
import { CustomerMealResponseDTO, ResponsePattern } from '../../model/ResponsesDTO';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { isMobile } from 'react-device-detect';
import { DinneyResponseStatus } from '../util/DinneyResponseStatus';

export const CustomersToMealTransferModal : React.FC<{meal : Meal, 
    customerList : Customer[], index : number | null,
    showTransfer : boolean, setShowTransfer : Dispatch<SetStateAction<boolean>>
}> = (props) => {
    const axiosInstance = useAxios() as ProviderValue
    const {meal, customerList, index, showTransfer, setShowTransfer} = props
    const [allCustomers, setAllCustomers] = useState<Customer[]>()
    const [loading, setLoading] = useState<boolean>(false)
    const controller = new AbortController();
    const signal = controller.signal

    useEffect(() => {
        if (customerList !== undefined) {
            setAllCustomers(customerList.filter(customer => meal.customerMeals !== undefined && meal.customerMeals?.length > 0 ? !meal.customerMeals.filter(customerMeal => customerMeal.customermealEnd === null || dayjs(customerMeal.customermealEnd).isAfter(dayjs().startOf('month'))).map(customerMeal=>customerMeal.customer.customerid).includes(customer.customerid) : customerList))
        }
    // eslint-disable-next-line
    },[showTransfer])

    const handleExit = () => {
        setShowTransfer(false)
      }

    const handleAdd = async (customer : Customer) => {
        setLoading(true)
        let beginDate = new LocalDate(dayjs(dayjs()).format('YYYY-MM-DD'))
        let requestCustomerMeal = new CustomerMeal(customer, meal, beginDate)
        let customermealRequestDTO = new CustomerMealRequestDTO(requestCustomerMeal, ResponsePattern.CUSTOMER)
        let responseCustomerMeal : CustomerMeal | undefined
        await axiosInstance.post<CustomerMealResponseDTO>(`/customermeals/secure/save`, customermealRequestDTO, {signal}).then((response) => {
            responseCustomerMeal = response.data.customerMealForCustomerPattern
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
        if (responseCustomerMeal !== undefined) {
            if (meal.customerMeals === undefined) {
                meal.customerMeals = []
            }
            meal.customerMeals.push(responseCustomerMeal)
            setAllCustomers(customerList.filter(customer => !meal.customerMeals?.filter(customerMeal => customerMeal.customermealEnd === null || dayjs(customerMeal.customermealEnd).isAfter(dayjs().startOf('month'))).map(customerMeal=>customerMeal.customer.customerid).includes(customer.customerid)))
        }
        setLoading(false)
        return () => {
            controller.abort()
        }
    }

    const handleArchiveRestore = async (customerMeal : CustomerMeal, isArchive : boolean) => {
        setLoading(true)
        let endDate : LocalDate
        await axiosInstance.delete<CustomerMealResponseDTO>(`/customermeals/secure/${isArchive ? `archive` : `restore`}/${customerMeal.customermealid}`, {signal}).then((response) => {
            endDate = response.data.customermealEnd
            customerMeal.customermealEnd = endDate
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
        setLoading(false)
        return () => {
            controller.abort()
        }
    }

    const handleDelete = async (customerMeal : CustomerMeal) => {
            setLoading(true)
            let responseStatus : DinneyResponseStatus | undefined
            await axiosInstance.delete<DinneyResponseStatus>(`/customermeals/secure/delete/${customerMeal.customermealid}`, {signal}).then((response) => {
                responseStatus = response.data
            }).catch((e) => {
                console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
            })
            if (responseStatus !== undefined) {
                meal.customerMeals = meal.customerMeals!.filter(currentCustomerMeal => currentCustomerMeal.customermealid !== customerMeal.customermealid)
                setAllCustomers(customerList.filter(customer => meal.customerMeals !== undefined && meal.customerMeals?.length > 0 ? !meal.customerMeals.filter(customerMeal => customerMeal.customermealEnd === null || dayjs(customerMeal.customermealEnd).isAfter(dayjs().startOf('month'))).map(customerMeal=>customerMeal.customer.customerid).includes(customer.customerid): customerList))
            }
            setLoading(false)
            return () => {
                controller.abort()
            }
    }

    return(
    <Modal key={index} size='xl' show={showTransfer} backdrop={'static'} onHide={() => handleExit()}>
        <Modal.Header closeButton>
            {isMobile ?
            <Modal.Title as='div'>{`${meal.details} - Dodaj rodziców do posiłku`}</Modal.Title>
            :
            <Modal.Title>{`${meal.details} - Dodaj rodziców do posiłku`}</Modal.Title>
            }
            
        </Modal.Header>
        <Modal.Body>
        <Divider orientation="left">Rodzice powiązani z posiłkiem</Divider>
        <List
            size="small"
            bordered
            style= {meal.customerMeals !== undefined && meal.customerMeals?.length < 5 && meal.customerMeals?.length > 0 ? {minHeight: '17vh'} : {}}
            loading ={loading}
            dataSource={meal.customerMeals !== undefined ? meal.customerMeals
                            .filter(customerMeal => dayjs().startOf('month') < dayjs(customerMeal.customermealEnd) || customerMeal.customermealEnd === null) : []}
            pagination={{defaultCurrent: 1, pageSize: 5, showSizeChanger : false, position: 'top'}}
            renderItem={(customerMeal) => 
            <List.Item style={{paddingBlock: '0px'}}>
                <Col span={isMobile ? 15 : 12}>{`${customerMeal.customer.firstName} ${customerMeal.customer.lastName} `}
                    {customerMeal.customermealEnd === null ? 
                        ""
                        :
                        <Tooltip title={`To połączenie posiłek-rodzic ma zostać zdeaktywowane 
                        (stało się tak w wyniku bezpośredniej deaktywacji połączenia lub w wyniku deaktywacji rodzica lub posiłku). Na tej stronie będzie ono widoczne 
                        do dnia ${customerMeal.customermealEnd}.`} 
                            arrow placement="right">
                            <ErrorOutlineIcon fontSize="small" sx={{ color: 'orange' }}/>
                        </Tooltip>
                    }
                </Col>
                {isMobile ?
                <></>
                :
                <Col span={10}>Dziecko: {customerMeal.customer.childName}</Col>
                }
                <Col span={isMobile ? 3 : 1}>
                    { customerMeal.customermealEnd === null ?
                        <>
                        <Popconfirm
                            title="Deaktywuj połączenie posiłku i rodzica"
                            description="Na pewno chcesz deaktywować połączenie posiłek-rodzic?"
                            onConfirm={() => handleArchiveRestore(customerMeal, true)}
                            okText="Tak"
                            cancelText="Nie"
                        >
                            <Tooltip TransitionComponent={Zoom} title="Deaktywuj połączenie posiłku z rodzicem">
                                <span>
                                    <IconButton color="warning">
                                        <DeleteIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Popconfirm>
                        </>
                    :
                        <>
                        <Popconfirm
                        title="Aktywuj połączenie posiłku z rodzicem"
                        description="Na pewno chcesz aktywować połączenie posiłek-rodzic?"
                        onConfirm={() => handleArchiveRestore(customerMeal, false)}
                        okText="Tak"
                        cancelText="Nie"
                        >
                        <Tooltip TransitionComponent={Zoom} title={!customerMeal.customer.active ? `Nie można aktywować połączenia posiłku z rodzicem ponieważ sam rodzic jest zdezaktywowany`: `Aktywuj połączenie posiłku z rodzicem`}>
                            <span>
                                <IconButton color="warning" disabled={!customerMeal.customer.active}>
                                    <RestoreFromTrashIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        </Popconfirm>
                        </>
                    }
                  
                </Col>
                <Col span={isMobile ? 3 : 1}>
                <Popconfirm
                    title="Usuń połączenie posiłku z rodzicem"
                    description={<span style={{width:'200px', display: 'inline-block'}}>Na pewno chcesz usunąć połączenie posiłek-rodzic? Jeśli połączenie powstało w tym miesiącu, zostanie ono usunięte całkowicie. Jeśli powstało wcześniej, zostanie zdezaktywowane z datą na koniec poprzedniego miesiąca</span>}
                    onConfirm={() => handleDelete(customerMeal)}
                    okText="Tak"
                    cancelText="Nie"
                    >
                    <Tooltip TransitionComponent={Zoom} title="Usuń połączenie rodzica z posiłkiem">
                        <span>
                            <IconButton color="error">
                                <DeleteIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                    </Popconfirm>
                </Col>
            </List.Item>
            }
        />
        <Divider orientation="left">Wszyscy rodzice</Divider>
        <List
            size="small"
            bordered
            style= {allCustomers !== undefined && allCustomers?.length < 5 && allCustomers?.length > 0 ? {minHeight: '17vh'} : {}}
            pagination={{defaultCurrent: 1, pageSize: 5, showSizeChanger : false, position: 'top' }}
            dataSource={allCustomers}
            loading ={loading}
            renderItem={(customer) => 
                <>
                <List.Item style={{paddingBlock: '0px'}}>
                    <Col span={isMobile ? 15 : 10}>{customer.firstName} {customer.lastName}</Col>
                    {isMobile ?
                    <></>
                    :
                    <Col span={6}>Dziecko: {customer.childName}</Col>
                    }
                    <Col span={isMobile ? 3 : 2}>
                        <Tooltip TransitionComponent={Zoom} title="Dodaj do posiłków rodzica">
                            <IconButton onClick ={() => handleAdd(customer)}>
                            <AddCircleIcon color="success" />
                            </IconButton>
                        </Tooltip>
                    </Col>
                </List.Item>
                </>
            }
        />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleExit()}>
            Zamknij
          </Button>
        </Modal.Footer>
    </Modal>
    )
}